<div id="sidebar-wrapper" class="sidebar bg-theme bg-theme6">
    <div class="brand-logo">

        <img src="assets/images/logo_cnd_transparency.png" alt="Conade Logo">
    </div>
    <div class="sidebar-content" [perfectScrollbar]>
        <ul id="active-class" class="navigation active4">
            <li *ngFor="let menuItem of menuItems" [ngClass]="[menuItem.class]"
                [routerLinkActive]="menuItem.submenu.length != 0 ? '' : 'active'">
                <a [routerLink]="menuItem.class === '' ? [menuItem.path] : null" *ngIf="valido(menuItem)">
                    <i [ngClass]="[menuItem.icon]"></i>
                    <span class="menu-title">{{menuItem.title}}</span>
                    <span *ngIf="menuItem.badge != '' " [ngClass]="[menuItem.badgeClass]">{{menuItem.badge}}</span>
                </a>
                <ng-template #externalLinkBlock>
                    <a [routerLink]="[menuItem.path]" target="_blank">
                        <i [ngClass]="[menuItem.icon]"></i>
                        <span class="menu-title">{{menuItem.title}}</span>
                        <span *ngIf="menuItem.badge != '' " [ngClass]="[menuItem.badgeClass]">{{menuItem.badge}}</span>
                    </a>
                </ng-template>
                <ul class="menu-content" *ngIf="menuItem.submenu.length > 0">
                    <li *ngFor="let menuSubItem of menuItem.submenu"
                        [routerLinkActive]="menuSubItem.submenu.length > 0 ? '' : 'active'"
                        [ngClass]="[menuSubItem.class]">
                        <a [routerLink]="menuSubItem.submenu.length > 0 ? null : [menuSubItem.path]"
                            *ngIf="valido(menuSubItem)">
                            <i [ngClass]="[menuSubItem.icon]"></i>
                            <span class="sub-menu-title">{{menuSubItem.title}}</span>
                            <span *ngIf="menuSubItem.badge != '' "
                                [ngClass]="[menuSubItem.badgeClass]">{{menuSubItem.badge}}</span>
                        </a>
                        <ng-template #externalSubLinkBlock>
                            <a [routerLink]="[menuSubItem.path]">
                                <i [ngClass]="[menuSubItem.icon]"></i>
                                <span class="sub-menu-title">{{menuSubItem.title}}</span>
                                <span *ngIf="menuSubItem.badge != '' "
                                    [ngClass]="[menuSubItem.badgeClass]">{{menuSubItem.badge}}</span>
                            </a>
                        </ng-template>
                    </li>
                </ul>
            </li>
            <br>
            <br>
            <div class="p-3">
                <div *ngIf="authUS.idTipoUsuario === TipoUsuarioEnum.CONADE">
                    <i class="fas fa-calendar text-white"></i>
                    <span class="menu-title font-weight-bold ml-2 text-white">
                        {{ sidebarRoutesService.getAnioSeleccionado() === AnioInformacionEnum.AnioInformacion2025
                        ? 'Año 2025'
                        : 'AÑOS ANTERIORES' }}
                    </span>
                </div>
            </div>
        </ul>
    </div>
</div>